import styled from 'styled-components';
import { Button } from '@common/components';

export const PillStyled = styled(Button)`
  margin-right: 8px;
  margin-top: 16px;
`;
